export var ToolbarType;
(function (ToolbarType) {
    ToolbarType["Language"] = "language";
    ToolbarType["Date"] = "date";
    ToolbarType["Number"] = "number";
})(ToolbarType || (ToolbarType = {}));
export var LanguageMode;
(function (LanguageMode) {
    LanguageMode["Inspector"] = "inspector";
    LanguageMode["Pseudolocalization"] = "pseudolocalization";
})(LanguageMode || (LanguageMode = {}));
